module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-settings-selected@3x.png?1.0.17";